import classNames from 'classnames'

import { RichText } from '@src/quince-components/src'
import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { makeRichTextProps, getBlockContainerClassName } from '../rowOfImageTextBlocks.helpers'
import styles from '../rowOfImageTextBlocks.module.scss'

import SubSection from './SubSection'

interface SectionProps {
  sectionDetails: CustomSection
  containerClassName: string
}

const Section = ({ sectionDetails, containerClassName }: SectionProps) => {
  const headerProps = makeRichTextProps(sectionDetails)
  const blockContainerClassName = getBlockContainerClassName(sectionDetails)
  const sectionClassName = classNames(containerClassName, sectionDetails.classNames)
  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
  const layoutType = sectionDetails.layoutType

  if (!blockContainerClassName) {
    return null
  }

  const subsections = sectionDetails.subSections?.map(section => (
    <SubSection key={section.id} subSectionDetails={section} layoutType={layoutType} />
  ))

  const showCarousel = isMobile && layoutType === LAYOUT_TYPES.CAROUSEL

  return (
    <div className={sectionClassName} style={{ paddingRight: showCarousel ? '0rem' : '3rem' }}>
      <div style={{ paddingRight: showCarousel ? '3rem' : '0rem' }}>
        {headerProps ? (
          <RichText {...headerProps} className={classNames(headerProps.className)} />
        ) : (
          <div className={styles.header}>{sectionDetails?.title}</div>
        )}
      </div>
      <div className={blockContainerClassName}>
        {showCarousel ? <div className={styles.carouselContainer}>{subsections}</div> : subsections}
      </div>
    </div>
  )
}

export default Section
